const getAppointmentSource = (event) =>
    `/media/icons/agenda-source-${event.isOutlookSpecific ? 'outlook' : 'automanager'}.svg`;

export default getAppointmentSource;
